import { component } from 'picoapp';
import { TweenMax } from 'gsap';
import jump from 'jump.js';

class StaffCard {
  constructor(el, ctx) {
    this.el = el;
    this.ctx = ctx;
    this.identifier = el.dataset.identifier;
    this.content = el.querySelector('.Entry__details');
    this.toggler = el.querySelector('.Entry__figure');
    this.detailsWrapper = this.content.querySelector('.detailsWrapper');
    if (this.toggler) {
      this.togglerInitialText = this.toggler.innerText;
    }
    this.isOpen = false;
    this.bindEvents();
  }
  bindEvents() {
    this.ctx.on('Collapse', (state) => {
      if (state.identifier == this.identifier) {
        if (typeof this[state.action] === 'function') {
          this[state.action]();
        }
      }
    });
    if (this.toggler) {
      this.toggler.addEventListener('click', (e) => {
        this.ctx.emit('openStaffCard', { instance: this.el });
        this.toggle();
      });
    }

    window.addEventListener('resize', () => {
      /* if(this.el.style.height){
        this.el.style.removeProperty('height');
      };
      
      if (this.isOpen){
        this.close();
      } */
      if (this.isOpen) {
        this.resize();
      }
    },true);

    this.ctx.on('openStaffCard', (data) => {
      if (data.instance == this.el) {
          this.el.classList.remove('unfocus');
      } else {
          this.el.classList.add('unfocus');
          if (this.isOpen) {
              this.close();
          }
      }
    });
    this.ctx.on('openTab', (data) => {
      if (this.isOpen) {
          this.resize();
      }
    });
  }
  resize = function(){
    let newHeight = this.toggler.offsetHeight + this.detailsWrapper.offsetHeight;
    TweenMax.to( this.content, 0.4, { height: this.detailsWrapper.offsetHeight, autoAlpha: 1 });
    TweenMax.to( this.el, 0.4, { height: newHeight });
  }

  toggle() {
    if (!this.isOpen) {
      this.open();
    } else {
      this.close();
    }
  }
  open() {
    //TweenMax.set(this.content, { height: this.el.offsetHeight, opacity: 1 });
    //TweenMax.from(this.content, 0.2, { height: 0, immediateRender: false });
    this.el.classList.add('is-open');
    this.resize();
    window.setTimeout(() => {
      jump(this.el, {
          duration: 500
        });
    }, 400);
    this.isOpen = true;
    
  }
  close() {
    TweenMax.to(this.content, 0.25, { height: '0', opacity: 0 });
    TweenMax.to(this.el, 0.4, { height: this.toggler.offsetHeight });
    this.isOpen = false;
    // this.toggler.innerText = this.togglerInitialText;
    this.el.classList.remove('is-open');
  }
}

export default component((node, ctx) => {
  new StaffCard(node, ctx);
});
